import React from 'react'
import CopyLabel from '../copy/CopyDefinitions'
import Icon from './Icons'
import HeroDevice from './HeroDevice'
import {CREATE_ACCOUNT_LINK,DOWNLOAD_IOS_APP_LINK,DOWNLOAD_ANDROID_APP_LINK} from '../externalLinks'
import Particles from 'react-particles-js'
import particlesConfig from './particlesConfig.json'
import { OutboundLink } from 'gatsby-plugin-google-analytics'

class HeroDesktop extends React.Component{

  render() {

    
    return(
      <div className='heroDesktopContainer' >
        
        <div className='heroDesktop'>
        	<div className='heroDesktop-left'>
            <HeroDevice />        
            <div className='heroDesktop-plickersCard heroDesktop-plickersCard--front'>
              <Icon iconName='plickersCard-front' />
            </div>

            <div className='heroDesktop-plickersCard heroDesktop-plickersCard--back'>
              <Icon iconName='plickersCard-front' />
            </div>        
        	</div>
        	<div className='heroDesktop-right'>
        		<div className='heroDesktop-title'>
        		  <CopyLabel label='heroTitle'/>
        		</div>
        		<div className='heroDesktop-sub-1'>
        			<CopyLabel label='heroSub1'/>
        		</div>
        		<div className='heroDesktop-sub-2'>
        			<CopyLabel label='heroSub2'/>
        		</div>

                {!this.props.mobileOS &&
            		<OutboundLink className='heroDesktop-sign-up-btn' href={CREATE_ACCOUNT_LINK}>
            			<CopyLabel label='primarySignUp' />
            			<Icon iconName='chevron-right' />
            		</OutboundLink>
                }

                {this.props.mobileOS === 'iPad' &&
                    <a className='heroDesktop-sign-up-btn' href={DOWNLOAD_IOS_APP_LINK}>                        
                        <CopyLabel label='primarySignUpiPad' />
                        <Icon iconName='chevron-right' />
                    </a>
                }
                {this.props.mobileOS === 'iPhone' &&
                    <a className='heroDesktop-sign-up-btn' href={DOWNLOAD_IOS_APP_LINK}>                        
                        <CopyLabel label='primarySignUpiPhone' />
                        <Icon iconName='chevron-right' />
                    </a>
                }
                {this.props.mobileOS === 'Android' &&
                    <a className='heroDesktop-sign-up-btn' href={DOWNLOAD_ANDROID_APP_LINK}>                        
                        <CopyLabel label='primarySignUpAndroid' />
                        <Icon iconName='chevron-right' />
                    </a>
                }

        		<div className='heroDesktop-sign-up-btn-sub'>
        			<CopyLabel label='primarySignUpSub' />
        		</div>
        	</div>

        
        </div>
        <div className='heroDesktop-bg' >        
          <Particles params={particlesConfig}
            style={{
              position: 'absolute',
              bottom: '0px',
              right: '0px',
              left: '0px',
              bottom: '0px'
            }}
          />
          <div className='heroDesktop-bg-earthContainer'>
            
              <Icon iconName='planetEarth'/>
          </div>      
        </div>
      </div>
    )
  }
}

export default HeroDesktop
